<template>
  <div class="cockpit">
    <!-- 页头 -->
    <div class="ckHead">
      <div class="ckHeadIn">
        <div class="ckTitle">
          <h2>风控决策驾驶舱<em>Risk Cockpit</em></h2>
          <p>用工合规 · 应收暂支 · 欠薪 · 社保夯实率　四大风险域统一视图</p>
        </div>
        <div class="ckHeadRight">
          <span class="ckUpdate">数据更新于 {{ data.updatedAt }}</span>
          <span class="ckMock" v-if="useMock">演示数据 · 接口待接入</span>
          <el-button size="small" icon="el-icon-refresh" @click="loadAll">刷新</el-button>
          <el-button size="small" type="primary" icon="el-icon-download" @click="onExport">导出</el-button>
        </div>
      </div>
    </div>

    <div class="ckBody">
      <!-- 筛选栏 -->
      <div class="ckCard filterBar">
        <span class="fl">归属月</span>
        <el-date-picker v-model="filter.attrMonth" type="month" size="small" value-format="yyyyMM"
          placeholder="归属月" style="width:140px" @change="loadAll"></el-date-picker>
        <span class="fl">分公司</span>
        <el-select v-model="filter.branch" size="small" clearable filterable placeholder="全部分公司" style="width:170px" @change="loadAll">
          <el-option v-for="(o,i) in branchOptions" :key="i" :value="o" :label="o"></el-option>
        </el-select>
        <span class="fl">风险域</span>
        <el-select v-model="filter.domain" size="small" clearable placeholder="全部风险域" style="width:150px" @change="loadAll">
          <el-option v-for="(d,i) in domains" :key="i" :value="d.key" :label="d.name"></el-option>
        </el-select>
        <span class="fl">趋势</span>
        <el-radio-group v-model="filter.monthCount" size="mini" @change="renderTrend">
          <el-radio-button :label="6">近 6 月</el-radio-button>
          <el-radio-button :label="12">近 12 月</el-radio-button>
        </el-radio-group>
      </div>

      <!-- 核心指标 -->
      <div class="metricRow">
        <div class="metricCard" v-for="(m,i) in metricCards" :key="i" :style="{ borderLeftColor: m.color }">
          <div class="mcTop"><span>{{ m.label }}</span><i :style="{ background: m.color }"></i></div>
          <div class="mcVal" :style="{ color: m.color }">{{ m.value }}<small>{{ m.unit }}</small></div>
          <div class="mcSub">{{ m.sub }}</div>
        </div>
      </div>

      <!-- 四大风险域 -->
      <div class="domainRow">
        <div class="domainCard" v-for="(d,i) in domainCards" :key="i" @click="goDomain(d)">
          <div class="dcHead">
            <span class="dcDot" :style="{ background: d.color }"></span>
            <span class="dcName">{{ d.name }}</span>
            <span class="dcMom" :class="d.mom >= 0 ? 'up' : 'down'">{{ d.mom >= 0 ? '▲' : '▼' }} {{ Math.abs(d.mom) }}%</span>
          </div>
          <div class="dcNum">{{ d.active }}<small> 条活跃</small></div>
          <div class="dcBar"><i :style="{ width: d.pct + '%', background: d.color }"></i></div>
          <div class="dcFoot">
            <span>红色 <b :style="{ color: d.color }">{{ d.red }}</b> 条</span>
            <span>占比 {{ d.pct }}%</span>
            <span class="dcGo">查看详情 →</span>
          </div>
          <div class="dcSpark">
            <i v-for="(v,j) in d.trend" :key="j" :style="{ height: sparkHeight(v, d.trend) + 'px', background: d.color, opacity: .35 + (j / d.trend.length) * .65 }"></i>
          </div>
        </div>
      </div>

      <!-- 趋势 + 等级分布 -->
      <div class="chartRow">
        <div class="ckCard chartCard trendCard">
          <div class="ckCardHead">
            <h3>预警趋势 <small>按等级 / 归属月</small></h3>
            <span class="ckLegend">
              <i v-for="(l,i) in levelLegend" :key="i" :style="{ background: l.color }"></i>{{ levelLegend.map(x => x.name).join(' / ') }}
            </span>
          </div>
          <div ref="trendChart" class="ckChart" style="height:290px"></div>
        </div>
        <div class="ckCard chartCard levelCard">
          <div class="ckCardHead">
            <h3>风险等级分布 <small>点击扇区可筛选</small></h3>
          </div>
          <div ref="levelChart" class="ckChart" style="height:290px"></div>
        </div>
      </div>

      <!-- TOP10 + 处置效率 -->
      <div class="chartRow">
        <div class="ckCard chartCard topCard">
          <div class="ckCardHead">
            <h3>TOP10 风险排名 <small>点击柱子按该维度下钻</small></h3>
            <el-radio-group v-model="topDim" size="mini" @change="renderTop">
              <el-radio-button label="branch">分公司</el-radio-button>
              <el-radio-button label="partner">合伙人</el-radio-button>
              <el-radio-button label="achieveOwner">业绩归属人</el-radio-button>
              <el-radio-button label="project">项目</el-radio-button>
            </el-radio-group>
          </div>
          <div ref="topChart" class="ckChart" style="height:310px"></div>
        </div>
        <div class="ckCard chartCard effCard">
          <div class="ckCardHead"><h3>处置效率 <small>本月</small></h3></div>
          <div class="effRing">
            <div class="erVal">{{ eff.rate }}<small>%</small></div>
            <div class="erLab">核销 / 处置率</div>
          </div>
          <div class="effList">
            <div class="effItem" v-for="(e,i) in eff.items" :key="i">
              <div class="eiTop"><span>{{ e.name }}</span><b>{{ e.value }}</b></div>
              <el-progress :percentage="e.pct" :stroke-width="8" :show-text="false" :color="e.color"></el-progress>
            </div>
          </div>
          <div class="effTip">口径：本月已核销数 ÷（本月新增 + 上期遗留待处理）</div>
        </div>
      </div>

      <!-- 重点待办 -->
      <div class="ckCard">
        <div class="ckCardHead">
          <h3>重点待办预警 <small>{{ levelFilter ? levelName(levelFilter) + '级' : '全部等级' }} · 按等级排序</small></h3>
          <div>
            <el-button v-if="levelFilter" size="mini" @click="levelFilter = 0">清除等级筛选</el-button>
            <span class="ckCount">共 {{ todoRows.length }} 条</span>
          </div>
        </div>
        <el-table :data="todoRows" border size="small" :row-class-name="rowClass" style="width:100%">
          <el-table-column prop="alertNo" label="预警编号" width="140" align="center"></el-table-column>
          <el-table-column prop="domainName" label="风险域" width="110"></el-table-column>
          <el-table-column prop="subType" label="风险子类" width="140"></el-table-column>
          <el-table-column prop="projectName" label="项目 / 部门" min-width="170" show-overflow-tooltip></el-table-column>
          <el-table-column prop="branchName" label="分公司" width="130" show-overflow-tooltip></el-table-column>
          <el-table-column prop="attrMonth" label="归属月" width="90" align="center"></el-table-column>
          <el-table-column prop="personCount" label="涉及人数" width="90" align="center"></el-table-column>
          <el-table-column label="金额(元)" width="130" align="right">
            <template slot-scope="s">{{ fmtMoney(s.row.amount) }}</template>
          </el-table-column>
          <el-table-column label="等级" width="80" align="center">
            <template slot-scope="s"><span class="lvTag" :style="lvStyle(s.row.level)">{{ s.row.levelName }}</span></template>
          </el-table-column>
          <el-table-column prop="statusName" label="状态" width="90" align="center"></el-table-column>
          <el-table-column label="操作" width="90" align="center">
            <template slot-scope="s">
              <el-button type="text" size="mini" @click="goAlert(s.row)">处理</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import xz from '@/common'
import * as echarts from 'echarts'

const LV_COLOR = { 4: '#FF3B5C', 3: '#FF9F1C', 2: '#FFC531', 1: '#2E7BFF' }
const LV_NAME = { 4: '红色', 3: '橙色', 2: '黄色', 1: '蓝色' }

// ============================================================
// 数据接入开关：后台接口定好后把 USE_MOCK 改成 false，并把 API_NAME 换成实际接口名
// 接口契约见文件末尾 fetchDashboard() 注释
// ============================================================
const USE_MOCK = true
const API_NAME = 'GetRiskDashboard'

const DOMAIN_DEF = [
  { key: 'labor', name: '用工合规', color: '#7C5CFF', route: '/laborCompliance' },
  { key: 'ar', name: '应收暂支未清', color: '#2E7BFF', route: '/arUncleared' },
  { key: 'payroll', name: '欠薪', color: '#FF9F1C', route: '/payrollWarn' },
  { key: 'social', name: '社保夯实率', color: '#00A576', route: '/socialRateWarn' }
]

// ---- 演示数据（固定值，刷新不跳数，方便对样式） ----
const MOCK = {
  updatedAt: '2026-11-03 09:30',
  metrics: {
    activeCount: 731, redCount: 128, monthNewCount: 1393,
    over3MonthCount: 0, writeOffCount: 662, amount: 12845600
  },
  domains: [
    { key: 'labor', active: 386, red: 74, mom: 12.4, trend: [22, 25, 24, 29, 31, 33, 32, 36, 38, 40, 42, 46] },
    { key: 'ar', active: 152, red: 28, mom: -3.2, trend: [18, 17, 19, 18, 16, 17, 15, 16, 14, 15, 14, 13] },
    { key: 'payroll', active: 118, red: 21, mom: 5.8, trend: [9, 10, 11, 10, 12, 12, 13, 14, 13, 15, 16, 17] },
    { key: 'social', active: 75, red: 5, mom: -8.1, trend: [10, 10, 9, 9, 8, 8, 7, 7, 7, 6, 6, 5] }
  ],
  trend: {
    months: ['202512', '202601', '202602', '202603', '202604', '202605', '202606', '202607', '202608', '202609', '202610', '202611'],
    red: [42, 48, 45, 52, 58, 61, 66, 72, 78, 85, 96, 128],
    orange: [88, 92, 96, 101, 108, 112, 118, 126, 134, 142, 168, 214],
    yellow: [120, 126, 132, 138, 145, 152, 160, 168, 176, 186, 212, 268],
    blue: [56, 58, 60, 62, 65, 68, 70, 74, 78, 82, 96, 121]
  },
  level: { red: 128, orange: 214, yellow: 268, blue: 121 },
  top: {
    branch: [
      { name: '华东分公司', count: 128, red: 32, orange: 44, yellow: 38, blue: 14, amount: 2860000 },
      { name: '华南分公司', count: 112, red: 26, orange: 38, yellow: 34, blue: 14, amount: 2180000 },
      { name: '华北分公司', count: 96, red: 18, orange: 30, yellow: 34, blue: 14, amount: 1960000 },
      { name: '西南分公司', count: 84, red: 15, orange: 26, yellow: 30, blue: 13, amount: 1520000 },
      { name: '华中分公司', count: 72, red: 12, orange: 22, yellow: 27, blue: 11, amount: 1280000 },
      { name: '东北分公司', count: 61, red: 9, orange: 18, yellow: 24, blue: 10, amount: 980000 },
      { name: '西北分公司', count: 54, red: 7, orange: 15, yellow: 22, blue: 10, amount: 860000 },
      { name: '总部直属', count: 48, red: 5, orange: 12, yellow: 21, blue: 10, amount: 720000 },
      { name: '海外事业部', count: 42, red: 3, orange: 6, yellow: 22, blue: 11, amount: 320000 },
      { name: '未分配', count: 34, red: 1, orange: 3, yellow: 16, blue: 14, amount: 165600 }
    ],
    partner: [
      { name: '张明远', count: 86, red: 21, orange: 30, yellow: 25, blue: 10, amount: 1920000 },
      { name: '李承泽', count: 74, red: 18, orange: 25, yellow: 22, blue: 9, amount: 1640000 },
      { name: '王雅琴', count: 68, red: 15, orange: 22, yellow: 22, blue: 9, amount: 1420000 },
      { name: '陈立群', count: 61, red: 13, orange: 20, yellow: 20, blue: 8, amount: 1260000 },
      { name: '赵文博', count: 55, red: 11, orange: 18, yellow: 18, blue: 8, amount: 1080000 },
      { name: '刘思远', count: 48, red: 9, orange: 15, yellow: 17, blue: 7, amount: 940000 },
      { name: '周慧敏', count: 42, red: 7, orange: 13, yellow: 15, blue: 7, amount: 820000 },
      { name: '孙浩然', count: 36, red: 6, orange: 11, yellow: 13, blue: 6, amount: 680000 },
      { name: '吴静怡', count: 30, red: 4, orange: 9, yellow: 12, blue: 5, amount: 520000 },
      { name: '未分配', count: 231, red: 24, orange: 71, yellow: 104, blue: 32, amount: 3565600 }
    ],
    achieveOwner: [
      { name: '郑海峰', count: 92, red: 22, orange: 32, yellow: 27, blue: 11, amount: 2060000 },
      { name: '林晓彤', count: 80, red: 19, orange: 27, yellow: 24, blue: 10, amount: 1780000 },
      { name: '何俊杰', count: 71, red: 16, orange: 24, yellow: 22, blue: 9, amount: 1520000 },
      { name: '高雪梅', count: 63, red: 13, orange: 21, yellow: 20, blue: 9, amount: 1320000 },
      { name: '马天宇', count: 56, red: 11, orange: 18, yellow: 19, blue: 8, amount: 1120000 },
      { name: '徐佳宁', count: 49, red: 9, orange: 16, yellow: 17, blue: 7, amount: 960000 },
      { name: '谢志强', count: 43, red: 7, orange: 14, yellow: 15, blue: 7, amount: 840000 },
      { name: '曹欣怡', count: 37, red: 6, orange: 11, yellow: 14, blue: 6, amount: 700000 },
      { name: '邓文昊', count: 31, red: 4, orange: 9, yellow: 12, blue: 6, amount: 560000 },
      { name: '未分配', count: 209, red: 21, orange: 62, yellow: 98, blue: 28, amount: 1985600 }
    ],
    project: [
      { name: '华东智能制造一期', count: 68, red: 18, orange: 24, yellow: 19, blue: 7, amount: 1680000 },
      { name: '华南供应链服务', count: 61, red: 15, orange: 21, yellow: 18, blue: 7, amount: 1420000 },
      { name: '华北物流外包', count: 54, red: 12, orange: 18, yellow: 17, blue: 7, amount: 1260000 },
      { name: '西南客服中心', count: 48, red: 10, orange: 16, yellow: 16, blue: 6, amount: 1080000 },
      { name: '华中研发外包', count: 42, red: 8, orange: 14, yellow: 14, blue: 6, amount: 920000 },
      { name: '东北仓储项目', count: 36, red: 6, orange: 12, yellow: 13, blue: 5, amount: 780000 },
      { name: '西北运维支持', count: 31, red: 5, orange: 10, yellow: 11, blue: 5, amount: 660000 },
      { name: '总部职能共享', count: 26, red: 4, orange: 8, yellow: 10, blue: 4, amount: 540000 },
      { name: '海外交付中心', count: 21, red: 2, orange: 6, yellow: 9, blue: 4, amount: 420000 },
      { name: '其他', count: 344, red: 48, orange: 85, yellow: 141, blue: 70, amount: 4085600 }
    ]
  },
  todo: [
    { alertNo: 'LA2026110001', domain: 'labor', domainName: '用工合规', subType: '未签合同已发薪', projectName: '华东智能制造一期', branchName: '华东分公司', attrMonth: '202611', personCount: 23, amount: 386000, level: 4, statusName: '待处理' },
    { alertNo: 'LA2026110002', domain: 'labor', domainName: '用工合规', subType: '合同签订合规', projectName: '华南供应链服务', branchName: '华南分公司', attrMonth: '202611', personCount: 18, amount: 0, level: 4, statusName: '跟进中' },
    { alertNo: 'PY2026110003', domain: 'payroll', domainName: '欠薪', subType: '欠薪', projectName: '华北物流外包', branchName: '华北分公司', attrMonth: '202610', personCount: 31, amount: 628000, level: 4, statusName: '待处理' },
    { alertNo: 'AR2026110004', domain: 'ar', domainName: '应收暂支未清', subType: '客户应收未清', projectName: '西南客服中心', branchName: '西南分公司', attrMonth: '202609', personCount: 0, amount: 1240000, level: 4, statusName: '跟进中' },
    { alertNo: 'LA2026110005', domain: 'labor', domainName: '用工合规', subType: '社保补缴风险', projectName: '华中研发外包', branchName: '华中分公司', attrMonth: '202611', personCount: 12, amount: 168000, level: 3, statusName: '待处理' },
    { alertNo: 'SO2026110006', domain: 'social', domainName: '社保夯实率', subType: '社保夯实率', projectName: '东北仓储项目', branchName: '东北分公司', attrMonth: '202611', personCount: 0, amount: 96000, level: 3, statusName: '待处理' },
    { alertNo: 'AR2026110007', domain: 'ar', domainName: '应收暂支未清', subType: '客户应收未清', projectName: '西北运维支持', branchName: '西北分公司', attrMonth: '202610', personCount: 0, amount: 540000, level: 3, statusName: '跟进中' },
    { alertNo: 'LA2026110008', domain: 'labor', domainName: '用工合规', subType: '长期服务用工', projectName: '总部职能共享', branchName: '总部直属', attrMonth: '202611', personCount: 7, amount: 0, level: 2, statusName: '待处理' }
  ]
}

export default {
  name: 'riskCockpit',
  data() {
    const now = new Date()
    return {
      useMock: USE_MOCK,
      filter: {
        attrMonth: '' + now.getFullYear() + String(now.getMonth() + 1).padStart(2, '0'),
        branch: '', domain: '', monthCount: 12
      },
      branchOptions: ['华东分公司', '华南分公司', '华北分公司', '西南分公司', '华中分公司', '东北分公司', '西北分公司', '总部直属', '海外事业部'],
      domains: DOMAIN_DEF,
      levelLegend: [
        { name: '红', color: LV_COLOR[4] }, { name: '橙', color: LV_COLOR[3] },
        { name: '黄', color: LV_COLOR[2] }, { name: '蓝', color: LV_COLOR[1] }
      ],
      data: { ...MOCK },
      topDim: 'branch',
      levelFilter: 0,
      charts: {}
    }
  },
  computed: {
    metricCards() {
      const m = this.data.metrics || {}
      return [
        { label: '活跃预警总数', value: this.fmtNum(m.activeCount), unit: ' 条', sub: '待处理 + 跟进中', color: '#7C5CFF' },
        { label: '红色高风险', value: this.fmtNum(m.redCount), unit: ' 条', sub: '需优先处置', color: '#FF3B5C' },
        { label: '本月新增', value: this.fmtNum(m.monthNewCount), unit: ' 条', sub: '较上月 +18.6%', color: '#2E7BFF' },
        { label: '超 3 月未核销', value: this.fmtNum(m.over3MonthCount), unit: ' 条', sub: '长期挂账风险', color: '#FF9F1C' },
        { label: '已累计核销', value: this.fmtNum(m.writeOffCount), unit: ' 条', sub: '自动 + 人工', color: '#00A576' },
        { label: '涉及金额', value: this.fmtWan(m.amount), unit: ' 万元', sub: '应收 / 欠薪 / 补缴', color: '#FFC531' }
      ]
    },
    domainCards() {
      const total = (this.data.metrics || {}).activeCount || 1
      const list = this.data.domains || []
      return DOMAIN_DEF.map(d => {
        const hit = list.find(x => x.key === d.key) || {}
        return {
          ...d,
          active: hit.active || 0, red: hit.red || 0, mom: hit.mom || 0,
          trend: hit.trend || [],
          pct: Math.round((hit.active || 0) * 100 / total)
        }
      })
    },
    eff() {
      const m = this.data.metrics || {}
      const writeOff = m.writeOffCount || 0
      const newCnt = m.monthNewCount || 1
      const rate = Math.min(100, Math.round(writeOff * 100 / newCnt))
      return {
        rate,
        items: [
          { name: '已核销', value: writeOff + ' 条', pct: rate, color: '#00A576' },
          { name: '跟进中', value: Math.round((m.activeCount || 0) * 0.36) + ' 条', pct: Math.round((m.activeCount || 0) * 36 / (newCnt || 1)), color: '#2E7BFF' },
          { name: '待处理', value: Math.round((m.activeCount || 0) * 0.64) + ' 条', pct: Math.round((m.activeCount || 0) * 64 / (newCnt || 1)), color: '#FF9F1C' }
        ]
      }
    },
    todoRows() {
      let rows = (this.data.todo || []).slice()
      if (this.filter.domain) rows = rows.filter(x => x.domain === this.filter.domain)
      if (this.filter.branch) rows = rows.filter(x => x.branchName === this.filter.branch)
      if (this.levelFilter) rows = rows.filter(x => x.level === this.levelFilter)
      return rows.map(x => ({ ...x, levelName: LV_NAME[x.level] || '-' }))
    }
  },
  mounted() {
    this.loadAll()
    window.addEventListener('resize', this.resizeCharts)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCharts)
    Object.keys(this.charts).forEach(k => { if (this.charts[k]) this.charts[k].dispose() })
  },
  methods: {
    // --------------------------------------------------------
    // 数据入口：目前走演示数据；接口定好后改 USE_MOCK=false 即可
    // --------------------------------------------------------
    async loadAll() {
      let d = null
      if (!USE_MOCK) d = await this.fetchDashboard()
      this.data = d || { ...MOCK, updatedAt: this.stamp() }
      this.renderTrend(); this.renderLevel(); this.renderTop()
    },
    async fetchDashboard() {
      // TODO 后台接口待定：约定 POST /Cbstc/EarlyWarn/GetRiskDashboard，入参见 buildParam()
      const r = await xz.EarlyWarn(this.buildParam(), API_NAME)
      if (!r || r.status !== 'ok' || !r.data) return null
      return r.data
    },
    buildParam() {
      return {
        AttrMonth: this.filter.attrMonth,
        Branch: this.filter.branch || null,
        Domain: this.filter.domain || null,
        MonthCount: this.filter.monthCount
      }
    },
    stamp() {
      const d = new Date()
      const p = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    },
    pick(o, key, def) {
      if (!o) return def
      if (o[key] !== undefined && o[key] !== null) return o[key]
      const up = key.charAt(0).toUpperCase() + key.slice(1)
      if (o[up] !== undefined && o[up] !== null) return o[up]
      return def
    },
    fmtNum(v) { const n = Number(v || 0); return n.toLocaleString('zh-CN') },
    fmtMoney(v) { return Number(v || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
    fmtWan(v) { return this.fmtNum(Math.round(Number(v || 0) / 10000)) },
    levelName(lv) { return LV_NAME[lv] || '' },
    lvStyle(lv) {
      const c = LV_COLOR[lv] || '#2E7BFF'
      return { background: c + '1A', color: c, border: '1px solid ' + c }
    },
    rowClass({ row }) { return row.level === 4 ? 'lvRowRed' : (row.level === 3 ? 'lvRowOrange' : '') },
    sparkHeight(v, arr) {
      const max = Math.max.apply(null, arr.concat([1]))
      return 6 + Math.round(v * 26 / max)
    },
    goDomain(d) { this.$router.push(d.route) },
    goAlert(row) {
      const d = DOMAIN_DEF.find(x => x.key === row.domain)
      this.$router.push(d ? d.route : '/laborCompliance')
    },
    onExport() { this.$message.info('导出接口待接入') },

    // --------------------------------------------------------
    // 图表
    // --------------------------------------------------------
    initChart(name, ref) {
      if (!this.charts[name] && this.$refs[ref]) this.charts[name] = echarts.init(this.$refs[ref])
      return this.charts[name]
    },
    resizeCharts() { Object.keys(this.charts).forEach(k => { if (this.charts[k]) this.charts[k].resize() }) },
    renderTrend() {
      const chart = this.initChart('trend', 'trendChart')
      if (!chart) return
      const t = this.data.trend || {}
      const n = this.filter.monthCount || 12
      const months = (t.months || []).slice(-n).map(m => m.length === 6 ? m.slice(0, 4) + '-' + m.slice(4) : m)
      const cut = a => (a || []).slice(-n)
      const mk = (name, color, arr) => ({
        name, type: 'line', smooth: true, symbol: 'none', stack: 'all',
        lineStyle: { width: 2, color }, itemStyle: { color },
        areaStyle: { color, opacity: 0.18 }, data: cut(arr)
      })
      chart.setOption({
        tooltip: { trigger: 'axis', axisPointer: { type: 'line' } },
        legend: { show: false },
        grid: { left: 12, right: 18, top: 22, bottom: 8, containLabel: true },
        xAxis: { type: 'category', boundaryGap: false, data: months, axisLine: { lineStyle: { color: '#E9EDF8' } }, axisLabel: { color: '#8A93AE', fontSize: 11 } },
        yAxis: { type: 'value', splitLine: { lineStyle: { color: '#EEF1F9' } }, axisLabel: { color: '#8A93AE', fontSize: 11 } },
        series: [
          mk('红', LV_COLOR[4], t.red), mk('橙', LV_COLOR[3], t.orange),
          mk('黄', LV_COLOR[2], t.yellow), mk('蓝', LV_COLOR[1], t.blue)
        ]
      }, true)
    },
    renderLevel() {
      const chart = this.initChart('level', 'levelChart')
      if (!chart) return
      const lv = this.data.level || {}
      const items = [
        { name: '红色（高风险）', value: lv.red || 0, itemStyle: { color: LV_COLOR[4] } },
        { name: '橙色（重点）', value: lv.orange || 0, itemStyle: { color: LV_COLOR[3] } },
        { name: '黄色（关注）', value: lv.yellow || 0, itemStyle: { color: LV_COLOR[2] } },
        { name: '蓝色（正常）', value: lv.blue || 0, itemStyle: { color: LV_COLOR[1] } }
      ]
      const total = items.reduce((s, x) => s + x.value, 0)
      chart.setOption({
        tooltip: { trigger: 'item', formatter: '{b}<br/>{c} 条 ({d}%)' },
        legend: { bottom: 0, itemWidth: 9, itemHeight: 9, textStyle: { fontSize: 11, color: '#6B7392' } },
        graphic: [
          { type: 'text', left: 'center', top: '39%', style: { text: String(total), textAlign: 'center', fill: '#141A33', fontSize: 28, fontWeight: 800 } },
          { type: 'text', left: 'center', top: '51%', style: { text: '活跃预警', textAlign: 'center', fill: '#8A93AE', fontSize: 12 } }
        ],
        series: [{
          type: 'pie', radius: ['54%', '74%'], center: ['50%', '45%'],
          avoidLabelOverlap: true, label: { show: false }, labelLine: { show: false },
          itemStyle: { borderColor: '#fff', borderWidth: 2, borderRadius: 4 },
          data: items
        }]
      }, true)
      chart.off('click')
      chart.on('click', p => {
        const map = { '红色（高风险）': 4, '橙色（重点）': 3, '黄色（关注）': 2, '蓝色（正常）': 1 }
        this.levelFilter = this.levelFilter === (map[p.name] || 0) ? 0 : (map[p.name] || 0)
        this.$message.success(this.levelFilter ? `已筛选${this.levelName(this.levelFilter)}级预警` : '已清除等级筛选')
      })
    },
    renderTop() {
      const chart = this.initChart('top', 'topChart')
      if (!chart) return
      const list = ((this.data.top || {})[this.topDim] || []).slice(0, 10).reverse()
      const names = list.map(x => this.pick(x, 'name', '未分配'))
      const mk = (name, color, key) => ({
        name, type: 'bar', stack: 'lv', barWidth: 14,
        itemStyle: { color, borderRadius: name === '蓝' ? [0, 3, 3, 0] : 0 },
        data: list.map(x => this.pick(x, key, 0))
      })
      chart.setOption({
        tooltip: {
          trigger: 'axis', axisPointer: { type: 'shadow' },
          formatter: ps => {
            const i = ps[0].dataIndex
            const row = list[i] || {}
            return `<b>${names[i]}</b><br/>预警 ${this.pick(row, 'count', 0)} 条<br/>金额 ${this.fmtMoney(this.pick(row, 'amount', 0))} 元`
          }
        },
        grid: { left: 8, right: 46, top: 26, bottom: 4, containLabel: true },
        legend: { data: ['红', '橙', '黄', '蓝'], top: 0, itemWidth: 9, itemHeight: 9, textStyle: { fontSize: 11 } },
        xAxis: { type: 'value', splitLine: { lineStyle: { color: '#EEF1F9' } }, axisLabel: { color: '#8A93AE', fontSize: 11 } },
        yAxis: {
          type: 'category', data: names, axisTick: { show: false }, axisLine: { show: false },
          axisLabel: { color: '#4A5470', fontSize: 11.5, width: 110, overflow: 'truncate' }
        },
        series: [
          mk('红', LV_COLOR[4], 'red'), mk('橙', LV_COLOR[3], 'orange'),
          mk('黄', LV_COLOR[2], 'yellow'), mk('蓝', LV_COLOR[1], 'blue')
        ]
      }, true)
      chart.off('click')
      chart.on('click', p => this.$message.info(`下钻「${p.name}」· 接口待接入（筛选值：${this.topDim}）`))
    }
  }
}
</script>

<style scoped>
.cockpit { min-height: 100%; background: #F3F5FC; padding-bottom: 60px; }
.ckHead { background: linear-gradient(115deg, #141A33 0%, #242A55 55%, #3B2C78 100%); padding: 22px 28px 26px; }
.ckHeadIn { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; }
.ckTitle h2 { margin: 0 0 6px; font-size: 27px; font-weight: 800; color: #fff; display: flex; align-items: center; }
.ckTitle h2 em { font-style: normal; font-size: 12px; font-weight: 600; letter-spacing: 1px; color: #B9A8FF; border: 1px solid rgba(185,168,255,.5); border-radius: 6px; padding: 3px 9px; margin-left: 12px; }
.ckTitle p { margin: 0; font-size: 12.5px; color: #A9B0CF; }
.ckHeadRight { display: flex; align-items: center; gap: 10px; }
.ckUpdate { font-size: 12px; color: #A9B0CF; }
.ckMock { font-size: 11px; color: #FFC531; border: 1px solid rgba(255,197,49,.45); background: rgba(255,197,49,.1); border-radius: 20px; padding: 3px 10px; }

.ckBody { padding: 18px 24px 0; }
.ckCard { background: #fff; border: 1px solid #E9EDF8; border-radius: 12px; box-shadow: 0 3px 14px rgba(30,40,90,.06); padding: 16px 18px; margin-bottom: 14px; }
.ckCardHead { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; flex-wrap: wrap; gap: 8px; }
.ckCardHead h3 { font-size: 16px; font-weight: 800; color: #141A33; margin: 0; }
.ckCardHead h3 small { font-size: 12px; font-weight: 400; color: #8A93AE; margin-left: 8px; }
.ckCount { font-size: 12px; color: #8A93AE; }
.ckLegend { font-size: 11px; color: #8A93AE; display: flex; align-items: center; gap: 5px; }
.ckLegend i { width: 8px; height: 8px; border-radius: 2px; display: inline-block; margin-left: 6px; }
.filterBar { display: flex; align-items: center; flex-wrap: wrap; gap: 2px; }
.fl { font-size: 13px; color: #6B7392; margin: 0 6px 0 14px; }
.fl:first-child { margin-left: 0; }

.metricRow { display: grid; grid-template-columns: repeat(6, 1fr); gap: 12px; margin-bottom: 14px; }
.metricCard { background: #fff; border: 1px solid #E9EDF8; border-left: 4px solid #7C5CFF; border-radius: 12px; box-shadow: 0 3px 14px rgba(30,40,90,.06); padding: 14px 16px; }
.mcTop { display: flex; align-items: center; justify-content: space-between; font-size: 12.5px; color: #6B7392; }
.mcTop i { width: 7px; height: 7px; border-radius: 50%; display: inline-block; }
.mcVal { font-size: 26px; font-weight: 800; line-height: 1.35; margin-top: 4px; }
.mcVal small { font-size: 12px; font-weight: 500; margin-left: 3px; }
.mcSub { font-size: 11.5px; color: #A0A8C0; margin-top: 2px; }

.domainRow { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; margin-bottom: 14px; }
.domainCard { position: relative; overflow: hidden; background: #fff; border: 1px solid #E9EDF8; border-radius: 12px; box-shadow: 0 3px 14px rgba(30,40,90,.06); padding: 14px 16px 12px; cursor: pointer; transition: transform .15s, box-shadow .15s; }
.domainCard:hover { transform: translateY(-2px); box-shadow: 0 8px 22px rgba(30,40,90,.13); }
.dcHead { display: flex; align-items: center; gap: 7px; font-size: 13px; }
.dcDot { width: 8px; height: 8px; border-radius: 50%; }
.dcName { font-weight: 700; color: #141A33; }
.dcMom { margin-left: auto; font-size: 11.5px; font-weight: 700; }
.dcMom.up { color: #FF3B5C; }
.dcMom.down { color: #00A576; }
.dcNum { font-size: 27px; font-weight: 800; color: #141A33; margin: 8px 0 6px; }
.dcNum small { font-size: 12px; font-weight: 500; color: #8A93AE; }
.dcBar { height: 5px; border-radius: 4px; background: #EEF1F9; overflow: hidden; }
.dcBar i { display: block; height: 100%; border-radius: 4px; }
.dcFoot { display: flex; justify-content: space-between; font-size: 11.5px; color: #8A93AE; margin-top: 8px; }
.dcFoot b { font-size: 12.5px; }
.dcGo { color: #7C5CFF; font-weight: 600; }
.dcSpark { position: absolute; right: 12px; bottom: 34px; height: 32px; display: flex; align-items: flex-end; gap: 2px; opacity: .5; pointer-events: none; }
.dcSpark i { width: 4px; border-radius: 2px 2px 0 0; display: block; }

.chartRow { display: grid; grid-template-columns: 2fr 1fr; gap: 14px; }
.chartRow:first-of-type { grid-template-columns: 2fr 1fr; }
.topCard { grid-column: 1; }
.effCard { grid-column: 2; }
.effRing { text-align: center; padding: 6px 0 12px; border-bottom: 1px dashed #EEF1F9; }
.erVal { font-size: 34px; font-weight: 800; color: #00A576; line-height: 1.2; }
.erVal small { font-size: 15px; }
.erLab { font-size: 12px; color: #8A93AE; margin-top: 2px; }
.effList { padding: 12px 2px 4px; }
.effItem { margin-bottom: 12px; }
.eiTop { display: flex; justify-content: space-between; font-size: 12.5px; color: #6B7392; margin-bottom: 5px; }
.eiTop b { color: #141A33; }
.effTip { font-size: 11px; color: #A0A8C0; border-top: 1px dashed #EEF1F9; padding-top: 10px; }

.lvTag { display: inline-block; font-size: 11px; padding: 2px 8px; border-radius: 10px; }
.ckChart { width: 100%; }
.cockpit /deep/ .lvRowRed { background: #FFF3F5 !important; }
.cockpit /deep/ .lvRowOrange { background: #FFF8EC !important; }

@media (max-width: 1400px) {
  .metricRow { grid-template-columns: repeat(3, 1fr); }
  .domainRow { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 1000px) {
  .chartRow { grid-template-columns: 1fr; }
  .topCard, .effCard { grid-column: 1; }
  .metricRow { grid-template-columns: repeat(2, 1fr); }
}
</style>
